import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	user: {
  		displayName: null,
  		photoURL: null,
      isInPurchaseView: false,
  	}
  },
  mutations: {
  	updateDisplayName(state, name) {
  		state.user.displayName = name
  	},
  	updatePhtoURL(state, url) {
  		state.user.photoURL = url
  	},
    updateIsInPurchaseView(state, val) {
      state.user.isInPurchaseView = val
    }
  },
  actions: {

  }
})
